module.exports = __webpack_public_path__ + "img/banner.ebcc8187.png";